import { connect } from 'react-redux';
import {
    closeNav,
    closeSearch,
    setSessionModal,
    unAuthUser,
    verifySessionUser
} from '../../actions';
import {
    getUserInfoLoading,
    getAuthentication,
    getSessionModal
} from '../../reducers';
import App from '../../components/app';

const mapStateToProps = state => ({
    userLoading: getUserInfoLoading(state),
    authentication: getAuthentication(state),
    userName: `${state.data.userInfo.rank} ${state.data.userInfo.firstName} ${
        state.data.userInfo.lastName
    }`,
    formSaved: state.events.formSaved,
    formTouched: state.forms.event.$form.touched,
    getSessionModal: getSessionModal(state)
});

const mapDispatchToProps = dispatch => ({
    closeNav: () => dispatch(closeNav()),
    closeSearch: () => dispatch(closeSearch()),
    setSessionModal: () => dispatch(setSessionModal()),
    unAuthUser: () => dispatch(unAuthUser()),
    verifySessionUser: () => dispatch(verifySessionUser())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/containers/app/index.js